import Router from "./Routes";
import ScrollToTop from "./Utiles/ScrollToTop";

function App() {
  return (
    <>
      <ScrollToTop />
      <Router />
    </>
  );
}

export default App;
